/*
  Il modulo di cambi, resi e annullamenti.

  Fa tre cose, tutte e tre per lo stesso motivo — che il cliente veda solo le
  domande che lo riguardano:

  1. mostra il ramo della scelta e nasconde gli altri due;
  2. **disabilita** i campi dei rami chiusi, se no Shopify li manda lo stesso e
     a Giuliano arriva una mail con delle righe vuote che sembrano domande
     rimaste senza risposta;
  3. rende obbligatori i campi del solo ramo aperto: `required` su un campo
     nascosto blocca l'invio e il browser non riesce nemmeno a dire dove, perche'
     non puo' mettere il fuoco su una cosa che non si vede.

  Senza questo file la pagina resta usabile: i rami sono chiusi dalla classe
  `gs-resi--js`, che mette il JS. Se il JS non parte, si vedono tutti i campi,
  niente e' obbligatorio a parte ordine ed email, e il modulo si invia lo
  stesso. Stessa scelta di gs-cap: prima funziona, poi si raffina.
*/
(() => {
  const moduli = document.querySelectorAll('.gs-resi__modulo');
  if (!moduli.length) return;

  moduli.forEach((modulo) => {
    const radio = modulo.querySelectorAll('[data-gs-resi-scelta]');
    const rami = modulo.querySelectorAll('[data-gs-resi-ramo]');
    if (!radio.length || !rami.length) return;

    const radice = modulo.closest('.gs-resi');
    if (radice) radice.classList.add('gs-resi--js');

    /* Un ramo chiuso non deve poter essere raggiunto col tab ne' letto da uno
       screen reader, e i suoi campi non devono partire: `hidden` toglie la
       prima cosa, `disabled` la seconda. */
    const apri = (ramo, aperto) => {
      ramo.hidden = !aperto;
      ramo.querySelectorAll('input, select, textarea').forEach((campo) => {
        campo.disabled = !aperto;
        if (campo.hasAttribute('data-gs-resi-obbligatorio')) {
          campo.required = aperto;
          campo.setAttribute('aria-required', String(aperto));
        }
      });
    };

    const scegli = (voce) => {
      rami.forEach((ramo) => apri(ramo, ramo.dataset.gsResiRamo === voce));
    };

    radio.forEach((r) => {
      r.addEventListener('change', () => {
        if (r.checked) scegli(r.dataset.gsResiScelta);
      });
    });

    /* Alla partenza nessuna voce e' scelta, quindi si chiude tutto. Il radio e'
       `required`, cosi' chi prova a inviare senza scegliere se lo sente dire dal
       browser invece di trovarsi un modulo che non fa niente. */
    const gia = modulo.querySelector('[data-gs-resi-scelta]:checked');
    scegli(gia ? gia.dataset.gsResiScelta : null);

    /* La nota sulla foto compare solo sui motivi in cui paga il negozio. Si
       riconoscono dalla posizione — sono gli ultimi due dell'elenco — e non da
       una parola scritta qui dentro: le parole le cambia Giuliano dall'editor,
       e un confronto su "difettoso" smetterebbe di funzionare in silenzio il
       giorno che le riscrive. */
    const motivo = modulo.querySelector('[data-gs-resi-motivo]');
    const notaFoto = modulo.querySelector('[data-gs-resi-nota-foto]');
    if (motivo && notaFoto) {
      const vere = Array.from(motivo.options).filter((o) => o.value !== '');
      const colpevoli = vere.slice(-2).map((o) => o.value);
      const aggiorna = () => {
        notaFoto.hidden = !colpevoli.includes(motivo.value);
      };
      motivo.addEventListener('change', aggiorna);
      aggiorna();
    }
  });
})();
